import React, {Component} from 'react'
import {Collapse, Button} from 'reactstrap'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import ProjectNoteInput from "./project/ProjectNoteInput"
import upsertProjectNotesMutation from '../../queries/server/mutations/upsert_project_notes'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'

class ProjectNoteCreate extends Component{

    constructor(props){
        super(props)
        this.form = null
    }

    state = {
        collapse: false,
        note: ''
    }

    toggle = () => {
        this.setState(state => ({collapse: !state.collapse}));
    }

    reset = () => {
        this.form.reset()
        this.setState({note: ''})
    }

    render(){

        const {collapse, note} = this.state
        const {project_id} = this.props

        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (
                    <div>
                        <Button
                            size="sm"
                            color={collapse ? 'warning' : 'success'}
                            onClick={this.toggle}
                        >
                            <FontAwesomeIcon color="#fff"
                                             icon={collapse ? 'minus' : 'plus'}/>{' '}{collapse ? 'Cancel' : 'Add Note'}
                        </Button>
                        <Mutation mutation={upsertProjectNotesMutation}>
                            {(upsertProjectNotesMutationFunc, {loading}) => (
                                <Collapse isOpen={collapse}>
                                    <div className="d-flex pt-3 mt-3 card card-body bg-light" style={{flex: 1}}>
                                        <ProjectNoteInput
                                            onFormCreated={(ref) => this.form = ref}
                                            note={note}
                                            saving={loading}
                                            onChange={(note) => this.setState({note})}
                                            onSave={() => {
                                                upsertProjectNotesMutationFunc({variables: {project_id, data: [{note}]}})
                                                    .then(({data}) => {
                                                        toast.success('Note Added', {autoClose: 2000})
                                                        editProjectLocalMutationFunc({variables: {data: data.upsertProjectNotes}})
                                                        this.toggle()
                                                        this.reset()
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                        />
                                    </div>
                                </Collapse>
                            )}
                        </Mutation>
                    </div>
                )}

            </Mutation>






        )
    }
}

export default ProjectNoteCreate